import { createDataActionFactory, Feature, createActionFactory } from '../../../../shared';
import type { Dispatch } from 'redux';
import setGroupSubscribeState from '../../../dataLayer/ows/groups/followGroup';
import { followGroupErrorNotification } from '../../user/groups/notificationBarActions';

export const followGroupClickedAction = createActionFactory<{
    groupId: string;
    hubPersonaId: string;
}>('FollowGroupClickedAction', Feature.UnifiedGroups);

export const unFollowGroupClickedAction = createActionFactory<{
    groupId: string;
    hubPersonaId: string;
}>('UnFollowGroupClickedAction', Feature.UnifiedGroups);

export const followGroupCompletedAction = createDataActionFactory<
    { groupId: string; groupSmtp: string; isFollowed: boolean; hubPersonaId: string },
    {
        groupId: string;
        groupSmtp: string;
        groupName: string;
        isFollowed: boolean;
        hubPersonaId: string;
    }
>(
    'FollowGroupCompletedAction',
    Feature.UnifiedGroups,
    action => ({ groupId: action.payload.groupId }),
    action => ({ groupId: action.payload.groupId })
);

export const unFollowGroupCompletedAction = createDataActionFactory<
    { groupId: string; groupSmtp: string; isFollowed: boolean; hubPersonaId: string },
    {
        groupId: string;
        groupSmtp: string;
        groupName: string;
        isFollowed: boolean;
        hubPersonaId: string;
    }
>(
    'UnFollowGroupCompletedAction',
    Feature.UnifiedGroups,
    action => ({ groupId: action.payload.groupId }),
    action => ({ groupId: action.payload.groupId })
);

export const toggleFollowGroup = (dispatch: Dispatch) => (
    groupSmtp: string,
    groupId: string,
    groupName: string,
    isFollowed: boolean,
    hubPersonaId: string,
    isRetry?: boolean
) => {
    setGroupSubscribeState(groupId, groupSmtp, isFollowed)
        .then(response => {
            dispatch(
                isFollowed
                    ? unFollowGroupCompletedAction.success({
                          groupId,
                          groupSmtp,
                          isFollowed: false,
                          hubPersonaId,
                      })
                    : followGroupCompletedAction.success({
                          groupId,
                          groupSmtp,
                          isFollowed: true,
                          hubPersonaId,
                      })
            );
        })
        .catch((error: Error) => {
            dispatch(
                isFollowed
                    ? unFollowGroupCompletedAction.error({
                          groupId,
                          groupSmtp,
                          groupName,
                          isFollowed: true,
                          hubPersonaId,
                      })
                    : followGroupCompletedAction.error({
                          groupId,
                          groupSmtp,
                          groupName,
                          isFollowed: false,
                          hubPersonaId,
                      })
            );
            followGroupErrorNotification(dispatch)(
                groupSmtp,
                groupId,
                groupName,
                isFollowed,
                isRetry,
                hubPersonaId
            );
        });
};
